// extracted by mini-css-extract-plugin
export default {"menu-container":"PrivateMenu_menu-container__ae9z8","selected-item":"PrivateMenu_selected-item__E-lO6","divider":"PrivateMenu_divider__vG+jt","logout":"PrivateMenu_logout__icQmM"};